import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as inscripcionesService from '../../services/inscripciones/inscripcionesService';
import {
  classifyInscripcionesError,
  formatInscripcionExamenCondicion,
  toUpdateInscripcionExamenPayload,
} from '../../services/inscripciones/inscripcionesDto';
import {
  formatMesaExamenInscripcionDisplay,
  formatMesaPeriodoDescripcion,
  parseLookupMesaExamenValue,
} from '../../services/mesas/mesasDto';
import { LookupMesaExamen } from '../MesaExamen/LookupMesaExamen';
import { LookupAlumnoCarrera } from '../AlumnoCarrera/LookupAlumnoCarrera';
import Select from '../common/AppSelect';
import { MdPageErrorMessage } from '../common/mdPageErrorMessage';
import { findSelectOptionByValue } from '../../services/selectOptions';

const optionsCuatrimestre = [
  { value: 'Regular', label: 'Regular' },
  { value: 'Libre', label: 'Libre' },
  { value: 'Equivalencia', label: 'Equivalencia' },
  { value: 'Promocion', label: 'Promoción' },
];

export class UpdateInscripcionExamen extends Component {
  static displayName = UpdateInscripcionExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingData: true,
      showErrorMessage: false,
      success: false,
      errorMessage: '',
      showLookupAnios: false,
      showLookupCursada: false,
      dictado: '',
      ignorarCorrelatividad: false,
      ignorarRegularidad: false,
      valueDictado: { value: '', label: '' },
      cursada: {
        cursadaCodigo: 0,
        cursadaMateriaCodigo: '',
        cursadaMateriaNombre: '',
        cursadaPeriodo: '',
      },
      mesaDisplay: '',
      alumno: {
        alumnocarreraCod: 0,
        alumnoNombre: '',
        alumnoCarrera: 0,
        alumnoCarreraNombre: '',
      },
      id: this.props.match.params.id,
      details: this.props.match.params.details,
    };
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWInscripcionExamen');
    if (canAccess) {
      await this.populateData();
    }
  }

  handleConfirmButton = () => {
    if (!this.isOkToSave()) {
      this.setState({ showErrorMessage: true, errorMessage: 'Todos los campos son obligatorios' });
      return;
    }
    this.saveStudent();
  };

  handleDictadoChangeInput = (e) => {
    this.setState({
      dictado: e.value,
      valueDictado: e,
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  handleCheckBoxCorrelatividad = (e) => {
    this.setState({ ignorarCorrelatividad: e.target.checked });
  };

  handleCheckBoxRegularidad = (e) => {
    this.setState({ ignorarRegularidad: e.target.checked });
  };

  async populateData() {
    this.setState({ loadingData: true });
    try {
      const data = await inscripcionesService.getInscripcionExamen(this.state.id);
      const nav = data.mesaExamenCodNavigation || {};
      const materiaCodigo = (nav.materiaCarreraCodigo || nav.materiaCarreraCod || '').trim();
      const mesaDisplay = formatMesaExamenInscripcionDisplay({
        materiaCarreraCodigo: materiaCodigo,
        materiaCarreraNombre: (nav.materiaCarreraNombre || '').trim(),
        carreraNombre: (data.alumnoxCarreraCodNavigation?.carreraNombre || '').trim(),
        periodoExamenDescripcion: (nav.periodoExamenDescripcion || '').trim(),
        periodoExamenLlamado: (nav.periodoExamenLlamado || '').trim(),
        anioAcademicoDescripcion: (nav.anioAcademicoDescripcion || '').trim(),
      });
      const defaultValuePractica = findSelectOptionByValue(
        optionsCuatrimestre,
        data.inscripcionExamenCondicionInsc
      );
      this.setState({
        loadingData: false,
        errorMessage: '',
        showErrorMessage: false,
        dictado: data.inscripcionExamenCondicionInsc.trim(),
        cursada: {
          cursadaCodigo: data.mesaExamenCod,
          cursadaMateriaCodigo: (nav.materiaCarreraCod || '').trim(),
          cursadaMateriaNombre: (nav.materiaCarreraNombre || '').trim(),
          cursadaPeriodo: formatMesaPeriodoDescripcion(nav),
        },
        mesaDisplay,
        alumno: {
          alumnocarreraCod: data.alumnoxCarreraCodNavigation.alumnoxCarreraCod,
          alumnoNombre: data.alumnoxCarreraCodNavigation.alumnoNombre.trim(),
          alumnoCarrera: data.alumnoxCarreraCodNavigation.carreraCod,
          alumnoCarreraNombre: data.alumnoxCarreraCodNavigation.carreraNombre.trim(),
        },
        valueDictado: defaultValuePractica,
      });
    } catch (error) {
      const outcome = classifyInscripcionesError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loadingData: false,
        errorMessage: outcome.message,
        showErrorMessage: true,
      });
    }
  }

  handleShowAniosLookup = () => {
    this.setState({ showLookupAnios: true });
  };

  handleShowCursadaLookup = () => {
    this.setState({ showLookupCursada: true });
  };

  handleHideLookup = () => {
    this.setState({ showLookupAnios: false });
  };

  handleHideLookup1 = () => {
    this.setState({ showLookupCursada: false });
  };

  handleSelectAnioItem = (e) => {
    const anioProperties = e.split('%');
    this.setState({
      alumno: {
        alumnocarreraCod: anioProperties[0],
        alumnoNombre: anioProperties[1],
        alumnoCarrera: anioProperties[3],
        alumnoCarreraNombre: anioProperties[2],
      },
      showLookupAnios: false,
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  handleSelectCursadaItem = (e) => {
    const mesa = parseLookupMesaExamenValue(e);
    this.setState({
      showLookupCursada: false,
      showErrorMessage: false,
      errorMessage: '',
      cursada: {
        cursadaCodigo: mesa.mesaExamenCod,
        cursadaMateriaCodigo: mesa.materiaCarreraCod,
        cursadaMateriaNombre: mesa.materiaCarreraNombre,
        cursadaPeriodo: formatMesaPeriodoDescripcion(mesa),
      },
      mesaDisplay: formatMesaExamenInscripcionDisplay(mesa),
    });
  };

  render() {
    if (this.state.success) {
      return <Redirect to="/md-ie" />;
    }

    const isDetail = this.state.details !== '0';
    const title = isDetail ? 'Detalle de Inscripción a Examen' : 'Modificar Inscripción a Examen';
    const { loading, loadingData } = this.state;
    const isBusy = loading || loadingData;
    const alumnoDisplay = (this.state.alumno.alumnoNombre + ' - ' + this.state.alumno.alumnoCarreraNombre).trim();
    const condicionDisplay = formatInscripcionExamenCondicion(this.state.dictado);

    return (
      <div className="md-page md-update-inscripcion-examen">
        <Link className="md-page__back-link" to="/md-ie">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">{title}</h1>
        </div>
        <p className="md-page__subtitle">
          {isDetail
            ? 'Consulte los datos registrados de la inscripción a examen.'
            : 'Actualice el alumno, la mesa de examen o la condición de inscripción.'}
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.errorMessage ? (
            <MdPageErrorMessage message={this.state.errorMessage} />
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están actualizando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <span className="md-page__field-label">Alumno</span>
            <div className="md-page__picker-block">
              {!isDetail && !isBusy ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowAniosLookup}>
                  Seleccionar alumno
                </button>
              ) : null}
              <div className="md-page__field-readonly">{alumnoDisplay}</div>
            </div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Mesa de examen</span>
            <div className="md-page__picker-block">
              {!isDetail && !isBusy ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowCursadaLookup}>
                  Seleccionar mesa de examen
                </button>
              ) : null}
              <div className="md-page__field-readonly">{this.state.mesaDisplay}</div>
            </div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Condición de inscripción</span>
            {isDetail ? (
              <div className="md-page__field-readonly">{condicionDisplay}</div>
            ) : (
              <Select
                className="md-page__field-select"
                value={this.state.valueDictado}
                options={optionsCuatrimestre}
                onChange={this.handleDictadoChangeInput}
                isDisabled={isBusy}
              />
            )}
          </div>

          {!isDetail ? (
            <>
              <div className="md-page__field">
                <label className="md-page__field-label">
                  <input
                    type="checkbox"
                    checked={this.state.ignorarCorrelatividad}
                    onChange={this.handleCheckBoxCorrelatividad}
                    disabled={isBusy}
                  />
                  {' '}Ignorar verificación de correlatividad
                </label>
              </div>

              <div className="md-page__field">
                <label className="md-page__field-label">
                  <input
                    type="checkbox"
                    checked={this.state.ignorarRegularidad}
                    onChange={this.handleCheckBoxRegularidad}
                    disabled={isBusy}
                  />
                  {' '}Ignorar verificación de regularidad
                </label>
              </div>

              <div className="md-page__form-actions">
                <button
                  type="button"
                  className="md-page__form-btn md-page__form-btn--primary"
                  onClick={this.handleConfirmButton}
                  disabled={isBusy}
                >
                  Guardar cambios
                </button>
              </div>
            </>
          ) : null}
        </div>

        {this.state.showLookupAnios ? (
          <LookupAlumnoCarrera selectItem={this.handleSelectAnioItem} hideLookup={this.handleHideLookup} />
        ) : null}
        {this.state.showLookupCursada ? (
          <LookupMesaExamen
            carreraCod={this.state.alumno.alumnoCarrera}
            selectItem={this.handleSelectCursadaItem}
            hideLookup={this.handleHideLookup1}
          />
        ) : null}
      </div>
    );
  }

  isOkToSave() {
    return this.state.dictado.length > 0;
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await inscripcionesService.updateInscripcionExamen(toUpdateInscripcionExamenPayload({
        id: this.state.id,
        alumnoxCarreraCod: this.state.alumno.alumnocarreraCod,
        mesaExamenCod: this.state.cursada.cursadaCodigo,
        condicion: this.state.dictado,
        materiaCarreraCod: this.state.cursada.cursadaMateriaCodigo,
        ignorarCorrelatividad: this.state.ignorarCorrelatividad,
        ignorarRegularidad: this.state.ignorarRegularidad,
      }));
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = classifyInscripcionesError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loading: false,
        success: false,
        showErrorMessage: true,
        errorMessage: outcome.message,
      });
    }
  }
}
